import { observer } from "mobx-react";
import { Access, accessToText } from "~/document";
import { RadioGroup, RadioGroupItem } from "~/components/ui/radio-group";
import { Label } from "~/components/ui/label";

interface Props {
  value: Access[];
  onChange: (newValue: Access[]) => void;
  selectProps: any;
}

const idToOption = (id: number) => {
  return {
    value: id,
    label: accessToText(id),
  };
};

const AccessLevelSelect = observer((props: Props) => {
  const value = props.value.map(idToOption);
  const options = [Access.Public, Access.LoginRequired].map(idToOption);
  const selected = value.length !== 0 ? String(value[0].value) : "";
  return (
    <RadioGroup
      value={selected}
      onValueChange={(v) => props.onChange([v as unknown as Access])}
      disabled={props.selectProps.disabled}
      className="gap-2"
    >
      {options.map((opt) => {
        const vs = String(opt.value);
        return (
          <div key={vs} className="flex items-center gap-2">
            <RadioGroupItem id={`access-${vs}`} value={vs} />
            <Label htmlFor={`access-${vs}`} className="cursor-pointer font-normal">
              {opt.label}
            </Label>
          </div>
        );
      })}
    </RadioGroup>
  );
});

export default AccessLevelSelect;
